import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import BusyIndicator from './BusyIndicator';

import classes from './loading.module.css';

const LoadingSpinner = ({ content = '', time = import.meta.env.MODE === 'test' ? 0.1 : 2 }) => {
    const [notFoundContent, setNotFoundContent] = useState(<BusyIndicator />);

    useEffect(() => {
        if (!content) return;
        const id = setTimeout(() => setNotFoundContent(content), time * 1000);
        return () => clearTimeout(id);
    }, [content, time]);

    return <div className={classes.loadingContent}>{notFoundContent}</div>;
};

LoadingSpinner.propTypes = {
    content: PropTypes.string,
    time: PropTypes.number
};

export default LoadingSpinner;
